import React, { useState, useEffect, useMemo } from 'react';
import {
  Grid,
  Card,
  CardContent,
  MenuItem,
  InputLabel,
  Select,
  CardActions,
  Button,
  FormControl,
  Typography,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  TextField,
  FormControlLabel,
  Input

} from "@mui/material"

import { Formik, Form, Field } from "formik"

import Load from '../extra/Load'
import {
  ButtonGroup,
  Divider,
  CardHeader
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux'
import * as Yup from "yup"
import { useMsal } from "@azure/msal-react";
import { postStudent } from '../function/axios';
import useMediaQuery from '@mui/material/useMediaQuery'
import { ufe_ingresarTNE } from '../function/axios';

const fieldset = {
  width: '100%',
  height: '100%',
  marginBottom: 3,
  padding: 0,
  border: '1px solid #000',
  borderRadius: 3,
  backgroundColor: "rgb(255, 255, 255,0.9)",
  paddingTop: 1
}


const contenedorDeInformacion = {
  width: '100%',
  height: '100%',
  margin: 3,
  marginBottom: 3,
  padding: 0,
  border: '1px solid #000',
  borderRadius: 3,
  backgroundColor: "rgb(255, 255, 255,0.9)",
  paddingTop: 1
}

const styleButtons = {
  backgroundColor: 'rgb(37,44,95)',
  color: "white"
}

const cardColor = {

  colorDesable: {



    backgroundColor: '#E5E9E9',

  },


}


//password validation
// const lowercaseRegEx = /(?=.*[a-z])/
// const uppercaseRegEx = /(?=.*[A-Z])/
// const numericRegEx = /(?=.*[0-9])/
// const lengthRegEx = /(?=.{6,})/

//validation schema
// let validationSchema = Yup.object().shape({
//   firstName: Yup.string().required("Required"),
//   lastName: Yup.string().required("Required"),
//   email: Yup.string().email("Invalid email").required("Required"),
//   password: Yup.string()
//     .matches(
//       lowercaseRegEx,
//       "Must contain one lowercase alphabetical character!"
//     )
//     .matches(
//       uppercaseRegEx,
//       "Must contain one uppercase alphabetical character!"
//     )
//     .matches(numericRegEx, "Must contain one numeric character!")
//     .matches(lengthRegEx, "Must contain 6 characters!")
//     .required("Required!"),
// })

const UserForm = () => {
  const { accounts } = useMsal();
  const [data, setData] = useState({});
  const [load, setLoad] = useState(true);
  const dispatch = useDispatch()
  const { estudiante } = useSelector(state => state.sesion)
  //console.log(estudiante, "estudiante")
  const rutSinCortar = estudiante.data[0].rut
  const rut = rutSinCortar.replace("-", "")
  //console.log("rut", rut)

  const [state, setState] = useState({
    rut: rutSinCortar
  });
  const { ingresaTNE } = useSelector(state => state.ingresaTNE)
  //console.log("ingresaTNE", ingresaTNE)
  //console.log("estudiante", estudiante)
  const listaTne = ingresaTNE.data
  // let arr = estudiante.sesion[0].rut.split('-');
  // const rut = arr[0]
  var today = new Date();
  var year = today.getFullYear();

  const match = useMediaQuery('(min-width:600px)')
  const breakpoint = match ? { width: '35vw', heigth: '50vw' } : { width: '90vw', heigth: '20vw' }
  const [complete, setComplete] = useState(false)

  useEffect(() => {

    const array = { rut: rut }

    postStudent(array).then((resp) => {
      //console.log('nn', resp)

      setData(resp)

    }).catch((error) => {
      //console.log("error", error)

    }).finally(() => {
      setLoad(false)

    })

  }, []);

  const SignupSchema = Yup.object().shape({


    proceso: Yup.string()


      .required('Debe completar la información'),

    fono: Yup.string()


      .required('Debe completar la información')





  });




  const onChange = (event) => {
    // //console.log(event.target)
    const { id, value, } = event.target



    // //console.log("eventos", { [id]: value })

    setState({ ...state, [id]: value })

  }

  const onChange2 = (event) => {

    const { name, value, } = event.target



    // //console.log("eventos", { [name]: value })

    setState({ ...state, [name]: value })

  }




  const onSubmit = (estado) => {

    setLoad(true)

    ufe_ingresarTNE(state).then((resp) => {

      console.log("resp", resp)

    }).finally(() => {

      setLoad(false)

    })

  }



  const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0
  })




  if (load) {

    return <Load />

  } else {
    //console.log("data", data)
    return (


      <Grid
        item
        xs={12}
        md={8}
        container
        alignItems="center"
        justifyContent="center"
        sx={{ marginTop: '30px', marginX: 'auto' }}

      >
        <Box sx={fieldset} component="fieldset" >

          <Grid sx={{ paddingTop: 5 }} />
          <Typography variant="h5" >  Formulario TNE {year} </Typography>




          <Grid sx={{ paddingTop: 2 }} />

          <CardContent sx={{
            color: 'rgb(37,44,95)',
            marginX: 4,
            fontSize: 14,
            textAlign: 'justify',
            lineHeight: 2,
          }} component="fieldset">
            <b>¡Atención!</b><br></br>
            Para editar mis datos personales ingresar <a href="https://alumnosnet.ugm.cl/Actualizador.asp" target="_blank">AQUÍ</a><br />
            los pasos a seguir son acceder con tu cuenta portal alumnos, perfil, actualizar datos.<br></br>
            Si tienes problemas con las credenciales de portal alumnos escribir a soporte@ugm.cl
          </CardContent>
          <Grid sx={{ paddingTop: 5 }} />
          <Formik
            initialValues={data[0]}
            onSubmit={onSubmit}>
            {({ dirty, isValid, values, handleChange, handleBlur }) => {
              return (
                <Grid>
                  <CardContent>
                    <Grid container spacing={2} justify="center">





                      <Grid item xs={12} md={4}>
                        <Field
                          label="Rut"
                          variant="outlined"
                          fullWidth
                          name="rut"
                          value={values.RUT_ALUMNO}
                          component={TextField}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>



                      <Grid item xs={12} md={4}>
                        <Field
                          label="Nombres"
                          variant="outlined"
                          fullWidth
                          name="names"
                          value={values.NOMBRE}
                          component={TextField}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          label="Apellidos"
                          variant="outlined"
                          fullWidth
                          name="apellidos"
                          value={values.APELLIDO_PATERNO + " " + values.APELLIDO_MATERNO}
                          component={TextField}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>


                      <Grid item xs={12} md={4}>
                        <Field
                          label="Correo Personal"
                          variant="outlined"
                          fullWidth
                          name="email"
                          value={values.CORREO}
                          component={TextField}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          label="Direccion"
                          variant="outlined"
                          fullWidth
                          name="direccion"
                          value={values.DIRECCION_ACTUAL}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />

                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          label="Comuna"
                          variant="outlined"
                          fullWidth
                          name="region"
                          value={values.COMUNA_ACTUAL}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />

                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Field
                          label="Movil(obligatorio)"
                          variant="outlined"
                          fullWidth
                          name="movil"
                          value={values.FONO_ACTUAL}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4} >
                        <Field
                          label="Periodo Ingreso"
                          variant="outlined"
                          fullWidth
                          name="fecha_ingreso"
                          value={values.AÑO_INGRESO + "-" + values.PERIODO_INGRESO}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          label="Jornada"
                          variant="outlined"
                          fullWidth
                          name="jornada"
                          value={values.JORNADA_ALUMNO}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          label="Estado académico"
                          variant="outlined"
                          fullWidth
                          name="jornada"
                          value={values.ESTADO_ACADEMICO}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          label="Tipo de carrera"
                          variant="outlined"
                          fullWidth
                          name="jornada"
                          value={values.TIPO_CARRERA}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Field
                          label="Situación académica"
                          variant="outlined"
                          fullWidth
                          name="SITUACION_ACADEMICA"
                          value={values.SITUACION_ACADEMICA}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <Field
                          label="Carrera"
                          variant="outlined"
                          fullWidth
                          name="carerra"
                          value={values.NOMBRE_CARRERA}
                          InputProps={{
                            readOnly: true,
                          }}
                          component={TextField}
                        />
                      </Grid>

                      <Grid sx={{ paddingTop: 5 }} xs={12} >
                        <Typography variant="h5" >  TNE {year} </Typography>
                      </Grid>
                    </Grid>

                    <Grid item md={12}>

                      <CardHeader title="Seleccione su tipo de solicitud"></CardHeader>

                      <Form>
                        <CardContent>
                          <FormControl>

                            <RadioGroup
                              defaultValue=""
                              name="proceso"

                            >
                              {listaTne.map((value) => (
                                <>
                                  <FormControlLabel
                                    value={value.id_proceso}
                                    control={<Radio disabled={parseInt(value.deshabilitado)} />}
                                    label={value.nombre_proceso}
                                    onChange={onChange2}
                                  />
                                  <Grid sx={{ paddingTop: 1 }} />

                                  <Card sx={{
                                    backgroundColor: value.deshabilitado != 0 ? "rgba(245, 243, 243,0.2) " : "white", color: value.deshabilitado != 0 ? "rgba(53, 51, 51,0.3) " : "black", fontSize: 14,
                                    textAlign: 'justify'
                                  }} disabled={parseInt(value.deshabilitado)} textAlign={"justify"} component="fieldset">
                                    {<div dangerouslySetInnerHTML={{ __html: value.descripcion_proceso }} />}
                                  </Card>
                                  <Grid sx={{ paddingTop: 2 }} />
                                </>

                              ))}
                            </RadioGroup>
                          </FormControl>

                        </CardContent>



                        <Grid sx={{ paddingTop: 5 }} xs={12} >
                          <Typography  >  Ingrese su numero de telefono </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ paddingTop: 2 }} >
                          <Field
                            variant="outlined"
                            fullWidth
                            name="fono"
                            id="fono"
                            type="number"

                            Defaultvalue={""}
                            component={TextField}
                            onChange={onChange}
                          />

                        </Grid>

                        <CardContent sx={{
                          color: 'rgb(37,44,95)',
                          marginY: 4,
                          fontSize: 14,
                          textAlign: 'center',
                          lineHeight: 2,
                        }} component="fieldset">
                                        Si presentas dudas para completar formulario de TNE puedes escribir a <a href="mailto:ufe@ugm.cl">ufe@ugm.cl</a>   indicando tu 
                          <b style={{color:'rgb(37,44,95)', paddingLeft:4}}>RUT/CONSULTA</b>

                        </CardContent>



                        <Grid sx={{ paddingTop: 4 }} />
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"

                          sx={styleButtons}
                          onClick={() => onSubmit("G")}
                        >
                          Ingresar
                        </Button>



                      </Form>


                    </Grid>

                  </CardContent>

                </Grid>
              )
            }}
          </Formik>
        </Box>
      </Grid>


    )
  }

}

export default UserForm


